<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo"></div>
          <h3>成都北新医院</h3>
          <p v-for="value in defaultInfos.foot_addr" :key="value">
            {{ value }}
          </p>
          <p v-for="value in defaultInfos.foot_phone" :key="value">
            {{ value }}
          </p>
          <!-- <p>邮箱：info@beixinhospital.com</p> -->
        </div>

        <div class="footer-section">
          <h4>快速链接</h4>
          <ul>
            <template v-for="value in mainNavInfo" :key="value.name">
              <li>
                <router-link :to="value.path">{{ value.label }}</router-link>
              </li>
            </template>
          </ul>
        </div>

        <div class="footer-section">
          <h4>医疗服务</h4>
          <ul>
            <li><router-link to="/">门诊服务</router-link></li>
            <li><router-link to="/">住院服务</router-link></li>
            <li><router-link to="/">健康检查</router-link></li>
            <li><router-link to="/">急诊急救</router-link></li>
            <li><router-link to="/">远程医疗</router-link></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>关注我们</h4>
          <div class="social-links">
            <div
              class="social-link"
              @mouseenter="showWechat()"
              @mouseleave="hideWechat()"
            >
              <img src="/Other/公众号.png" alt="公众号" />
              <span>微信公众号</span>
            </div>
            <div
              class="social-link"
              @mouseenter="showWeChatInfo()"
              @mouseleave="hideWeChatInfo()"
            >
              <img src="/Other/服务号.png" alt="医讯号" />
              <span>微信医讯号</span>
            </div>
          </div>
          <p style="margin-top: 15px">扫描二维码关注我们</p>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© {{ copyRight }} 成都北新医院 版权所有 | 蜀ICP备19001669号-1</p>
        <p>本网站所有内容仅供参考，不能作为诊断和治疗的依据</p>
      </div>
    </div>

    <!-- 使用二维码弹窗组件 -->
    <QrcodePopup :qr-info="qrCodeInfo" />
  </footer>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import QrcodePopup from "@/components/QrcodePopup/index.vue";
import { useDefaultInfoStore } from "@/stores/defaultInfo";
const defaultInfoStore = useDefaultInfoStore();

let defaultInfos = computed(() => defaultInfoStore.getFormateInfo);

const copyRight = ref(new Date().getFullYear());

const showwechat = ref(false);
const shwowechatinfo = ref(false);

const qrCodeInfo = ref([
  {
    visible: showwechat,
    title: "扫描关注医院公众号",
    imageSrc: "/Other/公众号.jpg",
    altText: "公众号",
  },
  {
    visible: shwowechatinfo,
    title: "扫描关注医院医讯号",
    imageSrc: "/Other/服务号.jpg",
    altText: "医讯号",
  },
]);
type NavItemType = {
  name: string;
  label: string;
  path: string;
};
const mainNavInfo = ref<NavItemType[]>([
  { name: "Home", label: "首页", path: "/" },
  { name: "AboutUs", label: "关于我们", path: "/about-us" },
  { name: "Doctors", label: "专家团队", path: "/doctors" },
  { name: "Departments", label: "科室介绍", path: "/departments" },
  { name: "News", label: "新闻动态", path: "/news" },
]);

function showWechat() {
  showwechat.value = true;
}

function hideWechat() {
  showwechat.value = false;
}

function showWeChatInfo() {
  shwowechatinfo.value = true;
}
function hideWeChatInfo() {
  shwowechatinfo.value = false;
}
</script>

<style scoped>
/* 底部样式 */
.footer {
  background: #1a5fb4;
  color: white;
  padding: 60px 0 30px;
}

.footer .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin: 10px 40px;
}

.footer-section h3,
.footer-section h4 {
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.footer-section p {
  margin-bottom: 10px;
  opacity: 0.9;
  line-height: 1.6;
  font-size: 0.95rem;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: white;
  text-decoration: none;
  opacity: 0.9;
  transition: opacity 0.3s;
  font-size: 0.95rem;
}

.footer-section ul li a:hover {
  opacity: 1;
  text-decoration: underline;
}

.social-links {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.social-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.social-link img {
  width: 24px;
  height: 24px;
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  margin: 5px 0;
  opacity: 0.8;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* 平板端适配 - 2列布局 */
@media (max-width: 1024px) {
  .footer {
    padding: 50px 0 25px;
  }

  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin: 10px 20px;
  }
}

/* 移动端适配 - 单列布局 */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer .container {
    padding: 0 15px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
    margin: 10px 0;
  }

  .footer-section h3,
  .footer-section h4 {
    font-size: 1.1rem;
    margin-bottom: 15px;
  }

  .footer-section p {
    font-size: 0.9rem;
  }

  .footer-section ul li a {
    font-size: 0.9rem;
  }

  .footer-bottom {
    padding-top: 20px;
  }

  .footer-bottom p {
    font-size: 0.85rem;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .footer {
    padding: 30px 0 15px;
  }

  .footer .container {
    padding: 0 10px;
  }

  .footer-section h3,
  .footer-section h4 {
    font-size: 1rem;
  }

  .footer-section p {
    font-size: 0.85rem;
  }

  .social-link {
    padding: 6px;
  }

  .social-link img {
    width: 20px;
    height: 20px;
  }

  .footer-bottom p {
    font-size: 0.8rem;
  }
}
</style>
